import React from "react";
import "./infoTooltip.css";
import InfoIcon from "assets/svgs/infoIcon";

const InfoTooltip = ({ message }) => {
  return (
    <span className="info-tooltip">
      <InfoIcon height={18} width={18} />
      <span className="info-tooltip-text">{message}</span>
    </span>
  );
};

export default InfoTooltip;
